import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { GatewayCommissioningStore, GATEWAY_COMMISSIONING_STEP } from '@store';

@Component({
  selector: 'app-check-light',
  templateUrl: './check-light.component.html',
  styleUrls: ['./check-light.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckLightComponent {
  readonly step = GATEWAY_COMMISSIONING_STEP;

  lightIsNotVisible = false;

  @Output() nextStep = new EventEmitter();
  @Output() previousStep = new EventEmitter();

  constructor(private gatewayCommissioningStore: GatewayCommissioningStore) {}

  nextStepClicked(): void {
    this.gatewayCommissioningStore.setActiveStep({
      activeStep: GATEWAY_COMMISSIONING_STEP.PROVIDE_TRANSFER_DATA,
    });
    this.nextStep.emit();
  }

  previousStepClicked(step: GATEWAY_COMMISSIONING_STEP): void {
    if (step === this.step.SELECT_INSTALLATION_TYPE) {
      this.gatewayCommissioningStore.clearState();
    } else {
      this.gatewayCommissioningStore.setActiveStep({
        activeStep: step,
      });
    }
    this.previousStep.emit();
  }
}
